import { defaultLandingPage } from './landingPages'

export const videoWatermarkRemovalSeo = defaultLandingPage.landingSeo
